import React from 'react';
import { AnimationWrapper, Particle1, Particle1After, Particle2, Particle2After, Particle3, Particle3After, Particle4, Particle4After } from './ParticlesLoader.styles';

export const ParticlesLoader = () => {
  return (
    <AnimationWrapper>
      <Particle1 />
      <Particle1After />
      <Particle2 />
      <Particle2After />
      <Particle3 />
      <Particle3After />
      <Particle4 />
      <Particle4After />
    </AnimationWrapper>
  );
};
